import "../styles/forms.css";

export default function AccountSettings() {
  return (
    <div className="pageDashB">
      <h2 className="dashboardPageTitleFont">Account</h2>

      <div className="form-card">
        <label className="dashboardPageSubTitleFont">Email</label>
        <input disabled value="megamindruler@gmail.com" />

        <label className="dashboardPageSubTitleFont">Name</label>
        <input value="kaushal" />

        <label className="dashboardPageSubTitleFont">Password</label>
        <input type="password" />

        <label className="dashboardPageSubTitleFont">Retype Password</label>
        <input type="password" />

        <button>Save Changes</button>
      </div>
    </div>
  );
}
